// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type chunkErrorWithExpiration = {
  value: string;
  expirationTime: number;
};

export function setChunkErrorExpiration(key: string, value: string, ttl: number) {
  const chunkError: chunkErrorWithExpiration = {
    value,
    expirationTime: new Date().getTime() + ttl,
  };

  localStorage.setItem(key, JSON.stringify(chunkError));
}

export function getChunkErrorExpiration(key: string) {
  const localStorageItem: string | null = localStorage.getItem(key);

  if (!localStorageItem) return null;

  const chunkError = JSON.parse(localStorageItem) as chunkErrorWithExpiration;
  const isExpired = new Date().getTime() > chunkError.expirationTime;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return chunkError.value;
}

export const removeChunkErrorExpiration = (key: string): void => {
  localStorage.removeItem(key);
};
